import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { Estate } from '../utils/enum.util';
import { PosturalService } from '../services/postural.service';

export class PosturalModel {

    private _id: string      = null;
    private _created: Date;
    private _updated: Date;
    private _clientPrivateId = '';
    private _measure1        = '';
    private _measure2        = '';
    private _measure3        = '';
    private _measure4        = '';
    private _measure5        = '';
    private _measure6        = '';
    private _measure7        = '';
    private _measure8        = '';
    private _measure9        = '';
    private _measure10        = '';
    private _comment        = '';
    private _title           = null;
    private _errors: any[];

    private _state: any = {
        title   : Estate.Noting,
        measure1: Estate.Noting,
        measure2: Estate.Noting,
        measure3: Estate.Noting,
        measure4: Estate.Noting,
        measure5: Estate.Noting,
        measure6: Estate.Noting,
        measure7: Estate.Noting,
        measure8: Estate.Noting,
        measure9: Estate.Noting,
        measure10: Estate.Noting,
        phoneFix: Estate.Noting
    };


    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public posturalService:PosturalService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************

    public modelChange(field: string) {
        //TODO : Anti rebond
        if (this._id == null)
            return this.create();
        this.updateOnField(field);
    }

    private updateOnField(field: string) {
        this.state[field] = Estate.Noting;
        if (this.validate() || !this.errors[field]) {
            this.posturalService.put(this, field);
        }
    }

    private create(){
        if (this.validate()) {
            this.posturalService.post();
        }
    }

    static j2o(data, posturalService) {
        let postural              = new PosturalModel(posturalService);
        postural._title           = data.title;
        postural._id              = data.id;
        postural._created         = data.created;
        postural._updated         = data.updated;
        postural._clientPrivateId = data.clientPrivateId;
        postural.title            = data.title;
        postural._measure1        = data.measure1;
        postural._measure2        = data.measure2;
        postural._measure3        = data.measure3;
        postural._measure4        = data.measure4;
        postural._measure5        = data.measure5;
        postural._measure6        = data.measure6;
        postural._measure7        = data.measure7;
        postural._measure8        = data.measure8;
        postural._measure9        = data.measure9;
        postural._measure10        = data.measure10;
        postural._comment        = data.comment;
        postural.state.title = Estate.Save;
        postural.state.measure1 = Estate.Save;
        postural.state.measure2 = Estate.Save;
        postural.state.measure3 = Estate.Save;
        postural.state.measure4 = Estate.Save;
        postural.state.measure5 = Estate.Save;
        postural.state.measure6 = Estate.Save;
        postural.state.measure7 = Estate.Save;
        postural.state.measure8 = Estate.Save;
        postural.state.measure9 = Estate.Save;
        postural.state.measure10 = Estate.Save;
        return postural;
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this._title, 'title', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._measure1, 'measure1', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure2, 'measure2', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure3, 'measure3', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure4, 'measure4', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure5, 'measure5', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure6, 'measure6', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure7, 'measure7', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure8, 'measure8', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure9, 'measure9', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._measure10, 'measure10', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42}}
            ])
            .addField(this._comment, 'comment', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 0, max: 1000}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //************** METHOD ***************
    //*************************************


    //*************************************
    //********** GETTER / SETTER **********
    //*************************************
    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get created(): Date {
        return this._created;
    }

    set created(value: Date) {
        this._created = value;
    }

    get updated(): Date {
        return this._updated;
    }

    set updated(value: Date) {
        this._updated = value;
    }

    get clientPrivateId(): any {
        return this._clientPrivateId;
    }

    set clientPrivateId(value: any) {
        this._clientPrivateId = value;
    }

    get measure1(): any {
        return this._measure1;
    }

    set measure1(value: any) {
        this._measure1 = value;
    }

    get measure2(): any {
        return this._measure2;
    }

    set measure2(value: any) {
        this._measure2 = value;
    }

    get measure3(): any {
        return this._measure3;
    }

    set measure3(value: any) {
        this._measure3 = value;
    }

    get measure4(): any {
        return this._measure4;
    }

    set measure4(value: any) {
        this._measure4 = value;
    }

    get measure5(): any {
        return this._measure5;
    }

    set measure5(value: any) {
        this._measure5 = value;
    }

    get measure6(): any {
        return this._measure6;
    }

    set measure6(value: any) {
        this._measure6 = value;
    }

    get title(): any {
        return this._title;
    }

    set title(value: any) {
        this._title = value;
    }

    get errors(): any[] {
        return this._errors;
    }

    set errors(value: any[]) {
        this._errors = value;
    }

    get state(): any {
        return this._state;
    }

    set state(value: any) {
        this._state = value;
    }

    get measure7(): string {
        return this._measure7;
    }

    set measure7(value: string) {
        this._measure7 = value;
    }

    get measure8(): string {
        return this._measure8;
    }

    set measure8(value: string) {
        this._measure8 = value;
    }

    get comment(): string {
        return this._comment;
    }

    set comment(value: string) {
        this._comment = value;
    }

    get measure9(): string {
        return this._measure9;
    }

    set measure9(value: string) {
        this._measure9 = value;
    }

    get measure10(): string {
        return this._measure10;
    }

    set measure10(value: string) {
        this._measure10 = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/postural.model.ts